import '@abraham/reflection';
import { EpJs } from './ep-js';
import './style/style.scss';
import * as packageObj from '../../../../package.json';
import { EpJsConfig } from './models/config.model';

let queue = [];
if(!!(window as any).EpJs && (window as any).EpJs.q){
  queue = (window as any).EpJs.q;
}

const sdkVersion = (packageObj as any).version;
const globalConfig = (window as any).EpJsConfig || (window as any).blispayConfig || {};

const baseConfig = { ...new EpJsConfig(globalConfig), sdkVersion };

const curScript = document.querySelector('script[data-blispay-js-key],script[data-ep-js-key]');

if (!!curScript && !!curScript.getAttribute('data-ep-js-key')) {
  baseConfig.apiKey = curScript.getAttribute('data-ep-js-key');
}

// @ts-ignore
__webpack_public_path__ = baseConfig.host;

const EpSdk = new EpJs();

queue.forEach((command: any[])=>{
  try {
    const method = command.shift();
    (EpSdk as any)[method](...command);
  }catch (e){
    console.log(e);
  }
});

/*
 * Only init if apiKey specified
 * */
if (!!baseConfig.apiKey) {
  EpSdk.init(baseConfig);
}

EpSdk.VERSION = sdkVersion;
window['EpJs'] = EpSdk;
export default EpSdk;
